





























import { Component, Vue, Prop } from 'vue-property-decorator'
import { SlideDeckPage } from '@/store/modules/slideDeck'

@Component
export default class EditSlideDeckPage extends Vue {
  @Prop() slideDeckPage!: SlideDeckPage;

  saveChanges () {
    this.$bvModal
      .msgBoxConfirm('Are you sure you wish to save changes?', {
        size: 'sm',
        buttonSize: 'sm',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (!value) {
          return
        }
        this.$store.dispatch('saveSlideDeckPage', this.slideDeckPage).then(() => {
          this.$bvModal.hide('edit-slide-deck-page-modal')
        })
      })
  }
}
